import { useState, useEffect } from 'react';

const usePageData = (pageSlug) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch(`/api/pages.php?page=${pageSlug}`);
        if (response.ok) {
          setData(await response.json());
        }
      } catch (err) {
        console.error(`Failed to load page data for ${pageSlug}:`, err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [pageSlug]);

  return { data, loading };
};

export default usePageData;
